import React from "react";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Login from "./components/pages/login/index.jsx";
import Layout from "./Layout/Layout.jsx";
import ServerError from "./pages/ServerError.jsx";
import routes from "./routes";
import defaultRoutes from "./routes/authetication.jsx";
import PatientsList from "./components/patients/PatientsList.jsx";

import Approuter from "./approuter";

import Modal from "react-modal";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/bootstrap.min.css";
//CSS & Bootstrap
import "./assets/css/style.css";
import "./assets/css/custom.css";
//  import "./assets/js/bootstrap.bundle.min.js";
import "./assets/css/select2.min.css";
//Font Awesome
import "./assets/css/font-awesome.min.css";
// import "./assets/plugins/fontawesome/css/all.min.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import { AuthProvider } from "./context/AuthContext.jsx";

//Routing
const router = createBrowserRouter([
  ...defaultRoutes,
  {
    path: "/admin",
    element: <Layout />,
    errorElement: <ServerError />,
    children: [
      ...routes,
      //    {
      //     path: "patients",
      //     element: <PatientsList />,
      // },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <AuthProvider>
    <RouterProvider router={router}></RouterProvider>
  </AuthProvider>
);

Modal.setAppElement("#root");